import React from "react";
import "./Page.css";

function Refund() {
  return (
    <div className="page">
      <div className="section-content" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
        <header>
          <h1 className="title fw-bold">REFUND POLICY</h1>
        </header>

        <section>
          <h2>REFUND POLICY FOR TOKE FOR STROKE OPEN GOLF TOURNAMENT</h2>
          <p>
            This Refund Policy applies to all registrations for the Toke For Stroke Open golf tournament event. 
            Please read this policy carefully before registering for the event.
          </p>
        </section>

        <section>
          <h2>REFUND ELIGIBILITY</h2>
          <p>
            <strong>Full Refunds:</strong> Full refunds will be granted in the following circumstances:
          </p>
          <ul>
            <li>
              <strong>Event Cancellation:</strong> If the event is cancelled by the organizers due to circumstances beyond our control 
              (including but not limited to severe weather, golf course closure, or government restrictions), you will receive a full refund 
              of your registration fee.
            </li>
            <li>
              <strong>Registration Error:</strong> If there was an error in processing your registration (e.g., duplicate charge, incorrect amount charged), 
              you will receive a full refund of the erroneous charge.
            </li>
            <li>
              <strong>Cancellation Request (30+ Days Before Event):</strong> If you request a cancellation at least 30 days before the event date 
              (April 20, 2026), you may be eligible for a full refund, subject to administrative review.
            </li>
          </ul>
          <p>
            <strong>Partial Refunds:</strong> Partial refunds may be granted in the following circumstances:
          </p>
          <ul>
            <li>
              <strong>Cancellation Request (14-29 Days Before Event):</strong> If you request a cancellation between 14 and 29 days before the event date, 
              you may be eligible for a 50% refund, subject to administrative review and our ability to fill your spot.
            </li>
            <li>
              <strong>Medical Emergency:</strong> In cases of documented medical emergencies preventing participation, partial or full refunds 
              may be granted at the discretion of event organizers.
            </li>
          </ul>
          <p>
            <strong>No Refunds:</strong> Refunds will NOT be granted in the following circumstances:
          </p>
          <ul>
            <li>
              Cancellation requests made less than 14 days before the event date
            </li>
            <li>
              Participant no-shows on the day of the event
            </li>
            <li>
              Weather-related issues that do not result in event cancellation (the event will proceed rain or shine unless conditions are unsafe)
            </li>
            <li>
              Personal schedule conflicts or changes of plans
            </li>
            <li>
              Removal from the event due to violation of golf course rules or inappropriate conduct
            </li>
          </ul>
        </section>

        <section>
          <h2>REFUND PROCESS</h2>
          <p>
            <strong>How to Request a Refund:</strong>
          </p>
          <ol>
            <li>
              Send an email to{" "}
              <a href="mailto:enterprisewebsolutions@outlook.com">
                enterprisewebsolutions@outlook.com
              </a>{" "}
              with the subject line "Refund Request - Toke For Stroke Open"
            </li>
            <li>
              Include your registration confirmation details (name, email, registration date)
            </li>
            <li>
              Provide the reason for your refund request
            </li>
            <li>
              For medical emergencies, include supporting documentation
            </li>
          </ol>
          <p>
            <strong>Refund Processing Time:</strong> Approved refunds will be processed within 7-14 business days. Refunds will be issued to the 
            original payment method used for registration.
          </p>
          <p>
            <strong>Refund Method:</strong> Refunds will be issued to the same credit card or payment method used for the original registration. 
            If the original payment method is no longer valid, alternative arrangements may be made at the discretion of event organizers.
          </p>
        </section>

        <section>
          <h2>REGISTRATION TRANSFERS</h2>
          <p>
            Instead of requesting a refund, you may transfer your registration to another person. Transfer requests must be submitted at least 7 days 
            before the event date and are subject to approval. To transfer your registration:
          </p>
          <ol>
            <li>
              Contact us at{" "}
              <a href="mailto:enterprisewebsolutions@outlook.com">
                enterprisewebsolutions@outlook.com
              </a>
            </li>
            <li>
              Provide your registration details and the new participant's information
            </li>
            <li>
              We will update the registration and confirm the transfer
            </li>
          </ol>
          <p>
            Note: Registration transfers are subject to event capacity and must be completed at least 7 days before the event date.
          </p>
        </section>

        <section>
          <h2>EVENT MODIFICATIONS</h2>
          <p>
            Event organizers reserve the right to modify the event date, time, format, or location due to circumstances beyond our control. 
            In such cases, registered participants will be notified as soon as possible. If the event is rescheduled, your registration will 
            automatically transfer to the new date. If you are unable to attend the rescheduled event, you may request a refund within 14 days 
            of the rescheduling announcement.
          </p>
        </section>

        <section>
          <h2>QUESTIONS</h2>
          <p>
            If you have any questions concerning our refund policy, please contact us at:
          </p>
          <p>
            <a href="mailto:enterprisewebsolutions@outlook.com">
              enterprisewebsolutions@outlook.com
            </a>
          </p>
          <p>
            We will respond to all refund inquiries within 3-5 business days.
          </p>
        </section>
        
        <p>Last updated: January 2025</p>
      </div>
    </div>
  );
}

export default Refund;
